var React = require('react');

function MusicAltSlash (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M272 352c-61.86 0-112 35.82-112 80s50.14 80 112 80 112-35.82 112-80v-5.18l-94.92-73.36A143.68 143.68 0 0 0 272 352zM438.94 1.33L342.4 29.84a32 32 0 0 0-22.4 30.5v155.22L384 265V148.15l73-21.39a32 32 0 0 0 23-30.71V32a32 32 0 0 0-41.06-30.67z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M633.82 458.1L45.47 3.39A16 16 0 0 0 23 6.2L3.37 31.47a16 16 0 0 0 2.81 22.45l588.35 454.71a16 16 0 0 0 22.47-2.81l19.63-25.27a16 16 0 0 0-2.81-22.45z","className":"fa-primary","key":2})]);
}

MusicAltSlash.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = MusicAltSlash;

MusicAltSlash.default = MusicAltSlash;
